export const consultationFeatureKey = 'consultation';
